import { Component, ComponentFactoryResolver, Injector, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ListItem } from '../../list-item';
import { ListPluginOptions } from '@kaiser-software/chassis-core';

@Component({
    selector: '[list-item]',
    templateUrl: 'list-item.component.html',
    styleUrls: ['list-item.component.scss']
})
export class ListItemComponent implements OnInit {

    /**
     * The ViewContainerRef instance.
     */
    @ViewChild('content', {read: ViewContainerRef}) content: ViewContainerRef;

    /**
     * The rendered component instance.
     */
    protected contentInstance: any;

    /**
     * The options of the list plugin.
     */
    @Input() options: ListPluginOptions;

    /**
     * List of items.
     */
    @Input() items;

    /**
     * Current item.
     */
    @Input() item;

    /**
     * The item index in the items list.
     */
    @Input() index;

    /**
     * Indicates if the item is the first in the items list.
     */
    @Input() first;

    /**
     * Indicates if the item is the last in the items list.
     */
    @Input() last;

    /**
     * The content template to render.
     */
    @Input() template: any;

    /**
     * The remove function inherited from the items list,
     */
    @Input() remove: Function;

    constructor(private componentFactoryResolver: ComponentFactoryResolver) {
    }

    ngOnInit() {
        this.renderContent();
        this.bindProperties();
    }

    protected renderContent() {
        const listItem = new ListItem();

        listItem.openRemoveModal = () => {
            this.remove(this.item);
        };

        const contentComponentFactory = this.componentFactoryResolver.resolveComponentFactory(this.template);

        const contentInjector = Injector.create({
            providers: [{
                provide: ListItem,
                useValue: listItem
            }],
        });

        const contentRef = this.content.createComponent(contentComponentFactory, null, contentInjector);

        this.contentInstance = contentRef.instance;
    }

    /**
     * Create the data bindings.
     */
    protected bindProperties() {
        ['items', 'item', 'index', 'first', 'last', 'options'].forEach((key) => {
            this.bindProperty(key);
        });
    }

    /**
     * Create an input binding.
     *
     * @param key
     */
    protected bindProperty(key) {
        this.contentInstance[key] = this[key];
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/plugins/abstract-plugins/list/components/list-item/list-item.component.ts